import React from "react";
import { motion } from "framer-motion";
import { SectionHeader } from "./About";

export default function Experience({ items }) {
  return (
    <section id="experience" className="py-24 md:py-32 relative border-t border-white/5" data-testid="experience-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <SectionHeader number="02" overline="Experience" title="7 years of experience building systems that survive production." />
        <div className="mt-14 relative">
          <div className="absolute left-2 md:left-1/2 top-0 bottom-0 w-px bg-white/10" />
          <div className="space-y-10">
            {items.map((e, i) => (
              <TimelineItem key={e.id} item={e} index={i} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function TimelineItem({ item, index }) {
  const leftSide = index % 2 === 0;
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.5 }}
      className="relative md:grid md:grid-cols-2 md:gap-12"
      data-testid={`experience-item-${index}`}
    >
      {/* Node */}
      <div className="absolute left-2 md:left-1/2 w-3 h-3 -translate-x-1/2 bg-volt rounded-full shadow-[0_0_16px_rgba(204,255,0,0.6)]" />

      {leftSide ? (
        <>
          <div className="pl-8 md:pl-0 md:pr-10 md:text-right">
            <Card item={item} />
          </div>
          <div />
        </>
      ) : (
        <>
          <div />
          <div className="pl-8 md:pl-10">
            <Card item={item} />
          </div>
        </>
      )}
    </motion.div>
  );
}

function Card({ item }) {
  return (
    <div className="card-tech p-5">
      <p className="overline text-volt">
        {item.start_date} → {item.current ? "PRESENT" : item.end_date || "—"}
      </p>
      <h3 className="mt-2 font-display font-semibold text-lg">{item.role}</h3>
      <p className="text-fog-300 text-sm mt-1">{item.company} · <span className="text-fog-400">{item.location}</span></p>
      {item.bullets && item.bullets.length > 0 && (
        <ul className="mt-4 space-y-2 text-sm text-fog-100 list-none">
          {item.bullets.slice(0, 4).map((b, i) => (
            <li key={i} className="flex gap-2 text-left">
              <span className="text-volt mt-1">▸</span>
              <span className="text-fog-200">{b}</span>
            </li>
          ))}
        </ul>
      )}
      {item.tech && item.tech.length > 0 && (
        <div className="mt-4 flex flex-wrap gap-1.5">
          {item.tech.map((t) => (
            <span key={t} className="tag-chip">{t}</span>
          ))}
        </div>
      )}
    </div>
  );
}
